import DefaultValidation from '@/services/validations/DefaultValidation';
import Message from '@/models/Message';
import * as Util from "@/functions/Util";

export default class Produtovalidation extends DefaultValidation {

    constructor(msgs) {
        super(msgs);
    }

    validate(model, refs, isUpdate) {
        let validated = true;

        if (Util.isNull(model.idprodutoerp)) {
            refs.codigoInput.focusedOut = true;
            validated = false;
        }

        if (Util.isNull(model.descricao)) {
            refs.descricaoInput.focusedOut = true;
            validated = false;
        }

        // if (Util.isNull(model.idgrupoproduto)) {
        //     refs.grupoSelect.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.idsubgrupoproduto)) {
        //     refs.subGrupoSelect.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.idlinhaproduto)) {
        //     refs.linhaSelect.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.idcategoria)) {
        //     refs.categoriaSelect.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.idramo)) {
        //     refs.ramoSelect.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.idcliente)) {
        //     refs.clienteSelect.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.idfamilia)) {
        //     refs.familiaSelect.focusedOut = true;
        //     validated = false;
        // }

        // if (isUpdate && Util.isNull(model.idunidademedida)) {
        //     refs.unidadeMedidaSelect.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.undmedida)) {
        //     refs.unidadeMedidaInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.embalagem)) {
        //     refs.descricaoEmbalagemInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.marca)) {
        //     refs.descricaoMarcaInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.codbarras)) {
        //     refs.codigoBarrasInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.undcaixa)) {
        //     refs.qtdItensCaixaInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.ncm)) {
        //     refs.ncmInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.cst)) {
        //     refs.cstInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.cest)) {
        //     refs.cestInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.ipi)) {
        //     refs.ipiInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.porctroca)||!Util.validatePorcentagem(model.porctroca)) {
        //     refs.porcentagemTrocaInput.focusedOut = true;
        //     validated = false;
        // }
        if (!Util.validatePorcentagem(model.porctroca)) {
            refs.porcentagemTrocaInput.focusedOut = true;
            validated = false;
        }

        // if (Util.isNull(model.espessura)) {
        //     refs.espressuraInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.comprimento)) {
        //     refs.comprimentoInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.peso)) {
        //     refs.pesoInput.focusedOut = true;
        //     validated = false;
        // }

        // if (Util.isNull(model.cubagem)) {
        //     refs.cubagemInput.focusedOut = true;
        //     validated = false;
        // }

        if (!validated){
            this.showMessage(new Message('alert', 'msg-campos-obrigatorios'));
        }

        return validated;
    }
}